import React, { useContext, useEffect, useState } from 'react';
import { ToastContext } from 'app/context/ToastContext';
import { Divider } from 'primereact/divider';
import './contract-page.css';
import { ProgressSpinner } from 'primereact/progressspinner';
import axios from 'axios';

export const ConditionPage = () => {
  const { showSuccess, showError } = useContext(ToastContext);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get('/api/configurations/client-personal-data')
      .then(r => {
        setData(r.data);
      })
      .catch(e => {
        console.error(e);
        showError('Chyba', e.response?.data?.detail);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h1 style={{ color: 'var(--primary-color)' }}>SPRACOVANIE OSOBÝCH ÚDAJOV</h1>

      <Divider className="client-divider" />
      {loading && (
        <div className="flex justify-content-center">
          <ProgressSpinner />
        </div>
      )}
      {!loading && data && (
        <>
          <div className="mb-4 contract-detail" style={{ border: `1px solid 'var(--primary-color)'` }}>
            <div style={{ backgroundColor: 'var(--primary-color)', padding: '0.5rem' }}>
              <h5 className="mb-0 text-white">SPRACOVANIE OSOBÝCH ÚDAJOV</h5>
            </div>
            <div className="flex align-items-center gap-3">
              <span className="flex align-items-center gap-2">
                <span className="three-line-clamp" dangerouslySetInnerHTML={{ __html: data }}></span>
              </span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ConditionPage;
